import $ from 'jquery'
import 'slick-carousel'

class StatsCarousel {
  constructor(el, userOptions, initCb) {
    this.el = el
    this.navItems = this.el.querySelectorAll('.slide .nav li')
    this.sliderEl = this.el.querySelector('.slides')
    this.started = false
    this.currentIndex = 0

    let options = {
      accessibility: true,
      arrows: false,
      dots: true,
      speed: 1000,
      mobileFirst: true,
    }

    if (userOptions) {
      options = userOptions
    }
    $(this.sliderEl).on('init', () => {
      if (typeof initCb === 'function') initCb()
    })
    $(this.sliderEl).slick(options)
    $(this.sliderEl).on('afterChange', (event, slick, currentSlide) => {
      const aos = slick.$slides[currentSlide].querySelectorAll('.aos-init')

      aos.forEach((el) => {
        el.style.visibility = 'visible'
        el.classList.add('aos-animate')
      })
    })
    $(this.sliderEl).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const aos = slick.$slides[nextSlide].querySelectorAll('.aos-init')

      aos.forEach((el) => {
        el.style.visibility = 'hidden'
        el.classList.remove('aos-animate')
      })
    })
    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        const slideIndex = parseInt(item.getAttribute('data-slide'))
        this.goto(slideIndex)
      })
    })
  }
  goto(index) {
    this.currentIndex = index
    $(this.sliderEl).slick('slickGoTo', index)

  }
}
export default StatsCarousel


// WEBPACK FOOTER //
// ./js/classes/stats-carousel.class.js